import React from 'react';
import {Link} from '../Link.jsx';
import {TextColor} from '../text-modifiers';
import {TrackingContextAppend} from '../TrackingContext.jsx';
import {CfEntry} from '../CfPreviewContext.jsx';
import {LinkBarV2} from './LinkBarV2.jsx';
import {CallToAction} from '../CallToAction.jsx';
import {XRay} from '../XRay.jsx';

/**
 * @typedef {TeaserLinkModel} TextTeaserModel
 * @property {String} entryId
 * @property {'TEXT_TEASER'} type
 * @property {String} text
 * @property {String} backgroundColor
 * @property {TextColor} textColor
 * @property {String} callToAction
 * @property {boolean} shouldRenderLink
 * @property {boolean} hasLinksInText
 * @property {string} contentType
 * @property {LinkBarV2} linkBar
 */

/**
 * @typedef {import('./ArticleOverviewTeaserContent.jsx').Device} Device
 */

/**
 * @param {TextTeaserModel} model
 * @param {Device} device
 * @returns {JSX.Element}
 */
export function TextTeaser({model, device}) {
    /** @var {import('react').RectNode} **/
    let content = (
        <div className="content-platform__teaser__container-wrapper">
            <div className="content-platform__teaser__container">
                <XRay fieldId="content" className="m-[30px] -extra-spacing" />
                <div
                    className="content-platform__rich-text content-platform__teaser__rich-text"
                    dangerouslySetInnerHTML={{__html: model.text}}
                ></div>
                <CallToAction text={model.callToAction} />
            </div>
        </div>
    );

    if (model.shouldRenderLink) {
        content = (
            <Link
                model={model}
                children={content}
                className="content-platform__teaser__link content-platform__teaser-target-link"
            />
        );
    }

    return (
        <TrackingContextAppend value={{id: model.entryId}}>
            <CfEntry entryId={model.entryId} contentType={model.contentType}>
                <article
                    className={`content-platform__teaser content-platform__teaser--text ${TextColor[model.textColor]} ${model.linkBar && '-aop-linkbar'}`}
                    style={{backgroundColor: model.backgroundColor}}
                >
                    <XRay fieldId="internalName" />
                    {content}
                    {model.linkBar && <LinkBarV2 model={model.linkBar} />}
                </article>
            </CfEntry>
        </TrackingContextAppend>
    );
}
